// :endpointId/docker/v:version/browse/:action

import { EnvironmentId } from '@/react/portainer/environments/types';

import { buildDockerProxyUrl } from '../../proxy/queries/buildDockerProxyUrl';

export function buildUrl({
  envId,
  version = 2,
  action,
}: {
  version?: number;
  envId: EnvironmentId;
  action: string;
}) {
  return buildDockerProxyUrl(envId, `v${version}`, 'browse', action);
}
